<template>
  <div id="TopBar">
    <div style="width: 10%; float: left">
      <h3>星雲鑑专业星盘系统</h3>
      <div class="subtitle">权威数据发布</div>
    </div>
    <div style="width: 30%; float: left; text-align: center">
      <div class="radio-bar astrolabe-type-buttons">
        <label v-for="option in astrolabeOptions" :key="option.value">
          <input
            type="radio"
            :value="option.value"
            v-model="selectedAstrolabeType"
            @change="handleAstrolabeTypeChange"
          />
          <span class="radio-label">{{ option.label }}</span>
        </label>
      </div>
    </div>
    <div v-if="hasPlanetPowerPermission" style="width: 80px; float: left; text-align: center">
      <button
        class="toggle-button"
        :class="{ 'active': scoreTableVisible }"
        @click="toggleScoreTable"
      >
        行星力量
      </button>
    </div>
    <!-- 保存图片：按需求与左右相邻按钮各留 10px 间距（2026-10-15）；
         其余顶部按钮仍保持原来的严丝合缝（见 .toggle-button 的注释） -->
    <div style="width: 80px; float: left; text-align: center; margin: 0 10px">
      <button
        class="toggle-button"
        @click="$emit('save-image')"
      >
        保存图片
      </button>
    </div>
    <!-- 相位搜索：按日期区间 + 和谐相位阈值筛出可用日期，结果以「日期 | 相位」表格呈现 -->
    <div style="width: 80px; float: left; text-align: center">
      <button
        class="toggle-button"
        @click="$emit('open-phase-search')"
      >
        相位搜索
      </button>
    </div>
    <!-- 开通功能：列出后端支持的 11 项可购买权限（9 项扫码付费 + 点报警/面报警两个 0 元项），
         扫码支付后自动开通，0 元项点击后直接开通一年。
         与前方按钮保持 20px 间距、独立成一项，避免与「相位搜索」等功能按钮混成一组 -->
    <div style="width: 80px; float: left; text-align: center; margin-left: 20px">
      <button
        class="toggle-button"
        @click="$emit('open-feature-purchase')"
      >
        开通功能
      </button>
    </div>
    <div style="width: 80px; float: right; text-align: center">
      <button
        class="toggle-button home-button"
        @click="fanhui"
      >
        返回主页
      </button>
    </div>
  </div>
</template>

<script>
import PermissionService from '@/services/PermissionService'

export default {
  name: 'TopBar',
  props: {
    scoreTableVisible: {
      type: Boolean,
      default: true
    },
    permissionMode: {
      type: String,
      default: PermissionService.PERMISSION_MODE_ALL_OPEN
    },
    permissions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      user: {}, // 记录用户信息
      selectedAstrolabeType: 'ecliptic',
      astrolabeOptions: [
        { label: '黄道盘', value: 'ecliptic' },
        { label: '地平黄道盘', value: 'horizon_ecliptic' },
        { label: '赤道盘', value: 'equatorial' },
        { label: '地平盘', value: 'horizon' }
      ]
    }
  },
  computed: {
    hasPlanetPowerPermission () {
      const granted = this.permissions.includes('planet_power')
      console.log('[TopBar] permission snapshot', {
        granted,
        permissionMode: this.permissionMode,
        propPermissions: this.permissions,
        servicePermissions: PermissionService.getPermissions()
      })
      return granted
    }
  },
  methods: {
    handleAstrolabeTypeChange () {
      this.$emit('astrolabe-type-change', this.selectedAstrolabeType)
    },
    toggleScoreTable () {
      this.$emit('toggle-score-table', !this.scoreTableVisible)
    },
    // 返回天星首页：与全站其它页面（siren / jizhai / dateSelection 等）的 fanhui() 口径保持一致
    fanhui () {
      this.$router.push('/tianxing/home')
    },
    hasPermission (key) {
      return PermissionService.hasPermission(key)
    }
  }
}
</script>

<style scoped>
#TopBar {
  width: 100%;
}

#TopBar h1 {
  margin: 0;
  font-size: 28px;
  letter-spacing: 1px;
  text-shadow: 0 0 10px rgba(100, 150, 255, 0.7);
}

#TopBar .subtitle {
  font-size: 14px;
  opacity: 0.85;
  margin-top: 5px;
  letter-spacing: 3px;
}

.radio-bar.astrolabe-type-buttons {
  display: flex;
  justify-content: center;
  background: transparent;
  padding: 2px;
}

.astrolabe-type-buttons label {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 32px;
  cursor: pointer;
  margin: 0;
}

.astrolabe-type-buttons input[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.radio-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #e0e0e0;
  color: #333;
  font-size: 12px;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.astrolabe-type-buttons label:first-child .radio-label {
  border-radius: 0;
}

.astrolabe-type-buttons label:last-child .radio-label {
  border-radius: 0;
}

.astrolabe-type-buttons input[type="radio"]:checked + .radio-label {
  background: #4a6fa5;
  color: white;
  box-shadow: 0 2px 4px rgba(74, 111, 165, 0.3);
}

.astrolabe-type-buttons label:hover .radio-label {
  background: #d0d0d0;
  color: #333;
}

.astrolabe-type-buttons input[type="radio"]:checked + .radio-label:hover {
  background: #3498db;
  color: white;
}

/* 顶部功能按钮（行星力量 / 保存图片 / 相位搜索 / 开通功能）：
   与左侧「黄道盘」按钮（.radio-label）同款 —— 直角无圆角、无 3D 投影、无按压位移、
   字体随页面，未选中 #e0e0e0、悬停 #d0d0d0，选中态 #4a6fa5（悬停 #3498db）。
   全局样式 `:where(#AstrolabeView) button`（assets/styles/global.css）会给按钮加 8px 圆角、
   3D 投影与 hover/active 位移，这里逐项覆盖掉（:where() 无优先级，普通类选择器即可盖住）。 */
.toggle-button {
  padding: 0;
  /* 只保留 2px 垂直外边距：与 .radio-bar 的 2px padding 对齐，水平方向相邻按钮严丝合缝 */
  margin: 2px 0;
  min-width: 80px;
  width: 80px;
  height: 32px;
  font-size: 12px;
  /* 字体随页面；字重对齐黄道盘按钮实际渲染值 500（来自全局 `:where(#AstrolabeView) label`）——
     button 默认是 UA 的 Arial + 400，不显式指定就会与黄道盘差一档 */
  font-weight: 500;
  font-family: inherit;
  background: #e0e0e0;
  color: #333;
  border: 1px solid transparent;
  border-radius: 0;
  box-shadow: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* 未选中：悬停 / 按下都只换底色（黄道盘按钮没有位移与投影反馈） */
.toggle-button:hover,
.toggle-button:active {
  background: #d0d0d0;
  transform: none;
  box-shadow: none;
}

/* 选中态（行星力量开启时），配色与黄道盘的 checked 态完全一致 */
.toggle-button.active {
  background: #4a6fa5;
  color: white;
  box-shadow: 0 2px 4px rgba(74, 111, 165, 0.3);
}

.toggle-button.active:hover,
.toggle-button.active:active {
  background: #3498db;
  color: white;
  box-shadow: 0 2px 4px rgba(74, 111, 165, 0.3);
  transform: none;
}

/* 仅「返回主页」按钮的样式调整，不影响其它按钮 */
.home-button {
  background: linear-gradient(135deg, #0ea5e9, #6366f1);
  color: #fff;
  font-weight: 600;
  border: 1px solid transparent;
  border-radius: 999px;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);
}

.home-button:hover {
  background: linear-gradient(135deg, #0284c7, #4f46e5);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(99, 102, 241, 0.45);
}

.home-button:active {
  transform: translateY(0);
}
</style>
